module.exports = __webpack_public_path__ + "static/img/logo_jt_2.74a0566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt_2.png
// module id = qUdD
// module chunks = 0